export const MAIN_URL = process.env.REACT_APP_MAIN_URL;
export const LOGIN_HUB_URL = process.env.REACT_APP_LOGIN_HUB_URL;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
